import React from 'react';
import { Route } from 'react-router-dom'
import ListTipoPublicaciones from "./ListTipoPublicaciones";
import TipoPublicacionesEdit from "./TipoPublicacionesEdit";
import TipoPublicacionesNew from "./TipoPublicacionesNew";
import BusquedaGrupoPlanes from './BusquedaGrupoPlanes';


export default class AdmTipoPublicaciones extends React.Component{

    render() {
        return (
            <div>
                <Route exact path="/Tipo/Publicaciones" component={ListTipoPublicaciones}/>
                <Route exact path="/Tipo/Publicaciones/Editar/:id" component={TipoPublicacionesEdit}/>
                <Route exact path="/Tipo/Publicaciones/Nuevo" component={TipoPublicacionesNew}/>            
                <Route exact path="/Tipo/Publicaciones/GrupoPlanes/Busqueda" component={BusquedaGrupoPlanes}/> 
            </div>
        );
    }
}